import React, { FC } from 'react';
import { getDevEnv } from '../../service/envConfig';
import { getEnvironmentAppUrls } from '@dvag/dfs-constant-config';
import { useParams } from 'react-router-dom';
import { DxContainer, DxSpacer } from '@dvag/design-system-react';
import { useCreateKssElement } from '../../hooks/useCreateKssElement';

export const KundenstammdatenNamensaenderung: FC = () => {
  const { kundennummer } = useParams();

  const env = getDevEnv();
  const appUrls = getEnvironmentAppUrls(env);
  const mfeBridgeIdentifier = 'kundenstammdatenNamensaenderung';
  const scriptSrc = appUrls.kundenstammdaten + '/namensaenderung/namensaenderung-frontend.js';

  const elementParams = {
    scriptSrc,
    querySelector: 'dvag-kundenstammdaten-namensaenderung',
    createElementParams: {
      mfeBridgeIdentifier,
      kundennummer,
    },
  };

  const kssChangeName = useCreateKssElement(elementParams);

  return (
    <DxContainer
      type="page"
      color="transparent"
      data-testid="name-change-container"
      id="name-change-container"
    >
      <DxSpacer size="32v" />
      {kssChangeName}
    </DxContainer>
  );
};
